import { createContext } from "react";
const UrlContext = createContext();

export { UrlContext };